import {
  Person, AttachMoney, GroupAdd, AddOutlined
} from '@mui/icons-material';

export const infoDetails = [
  { icon: <Person />, name: 'New User', count: '230', growth: '1% increase from previous month', color: '#35353a'  },
  { icon: <AttachMoney />, name: 'Revenue', count: '2300', growth: '1% increase from previous month', color: '#5db461'  },
  { icon: <GroupAdd />, name: 'User', count: '2300', growth: '1% increase from previous month', color: '#3d97ef'  },
  { icon: <AddOutlined />, name: 'Followers', count: '20', growth: '1% increase from previous month', color: '#e63573' },
]